import { Helmet } from "react-helmet-async";

export default function EducationLoanPage() {
    return (
      <div className="w-full min-h-screen bg-gray-100 p-4">
         <Helmet>
                <title>Kota HOLDINGS</title>
                <meta name="description" content="A Vision of My 30-Year World" />
              </Helmet>
        <div className="mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="bg-[#FF6F00] text-white p-6">
            <h2 className="text-2xl font-bold">Secure Your Future with an Education Loan</h2>
            <p className="mt-2">Get financial support for higher education with flexible repayment options.</p>
            <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
              <input type="text" placeholder="Your Name" className="p-2 rounded-md text-black" />
              <input type="tel" placeholder="+91 Phone" className="p-2 rounded-md text-black" />
              <input type="email" placeholder="Email" className="p-2 rounded-md text-black" />
            </div>
            <textarea placeholder="Message" className="w-full mt-4 p-2 rounded-md text-black"></textarea>
            <button className="mt-4 bg-blue-600 hover:bg-blue-900 text-white px-6 py-2 rounded-md">Apply Now</button>
          </div>
        </div>
        <div className="mx-auto overflow-hidden mt-6">
          <div className="p-6">
            <h3 className="text-xl font-bold">Common Documents Required</h3>
            <ul className="list-disc ml-6 mt-2">
              <li>Proof of identity (Aadhaar Card, Passport, Voter ID, PAN Card)</li>
              <li>Proof of residence (Electricity Bill, Rental Agreement, Passport)</li>
              <li>Admission letter from a recognized university or institution</li>
              <li>Mark sheets of previous academic qualifications</li>
              <li>Co-applicant’s income proof (Salary Slips, ITR, Bank Statements)</li>
              <li>Collateral documents (if applicable)</li>
            </ul>
          </div>
          <div className="p-6 bg-gray-50">
            <h3 className="text-xl font-bold">Features and Benefits of Education Loans</h3>
            <ul className="list-disc ml-6 mt-2">
              <li>Low interest rates</li>
              <li>Flexible repayment options up to 15 years</li>
              <li>Coverage for tuition fees, living expenses, and travel</li>
              <li>Loan available for studies in India and abroad</li>
              <li>Tax benefits under Section 80E</li>
            </ul>
          </div>
          <div className="p-6 bg-gray-50">
            <h3 className="text-xl font-bold">Eligibility Criteria</h3>
            <ul className="list-disc ml-6 mt-2">
              <li>Applicant must be an Indian citizen</li>
              <li>Secured admission in a recognized university or institution</li>
              <li>Co-applicant (parent/guardian) is required</li>
              <li>Good academic record</li>
              <li>Collateral may be required for higher loan amounts</li>
            </ul>
          </div>
        </div>
      </div>
    );
}
